import React from "react";
import { Error } from "@mui/icons-material";
import "./form_field_error.css";

const FormFieldError = ({
  style = {},
  className = "form-field-error__wrapper",
  errorMessage = "This field cannot be empty.",
}) => {
  return (
    <div className={className} style={style}>
      <Error style={{ fontSize: "14px", marginRight: "6px" }} />
      <p style={{ margin: "0", fontSize: "12px" }}>{errorMessage}</p>
    </div>
  );
};

export default FormFieldError;
